/**
 * index.js
 * Tổng hợp toàn bộ bảng tra cứu các tư thế cử động nhân vật hình hộp (Action Poses Registry).
 */

import { SOCIAL_POSES } from './social.js';
import { LOCOMOTION_POSES } from './locomotion.js';
import { PHYSICS_POSES } from './physics.js';
import { STREET_POSES } from './street.js';

export const ACTION_POSES = {
  ...SOCIAL_POSES,
  ...LOCOMOTION_POSES,
  ...PHYSICS_POSES,
  ...STREET_POSES
};
